// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_container__Py0eR {
  display: flex;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  position: relative;
  padding-top: 5rem;
}

.Dashboard_overlay__3rLKG {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 40;
}

/* Sidebar becomes a flex container so that the header remains fixed while the nav scrolls */
.Dashboard_sidebar__duGZ8 {
  background-color: #111;
  padding: 1rem;
  height: calc(100vh - 5rem); /* Adjust height to account for the top offset */
  position: fixed;
  left: -280px;
  top: 5rem;
  transition: left 0.3s ease;
  z-index: 50;
  display: flex;
  flex-direction: column;
}

.Dashboard_sidebar__duGZ8.Dashboard_open__DdRZ7 {
  left: 0;
}

.Dashboard_sidebarHeader__N0DXS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  flex-shrink: 0;
}

.Dashboard_logo__6\\+i8F {
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
}

.Dashboard_menuButton__UCLmC {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Dashboard_nav__POOmH {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 2rem;
}

.Dashboard_navButton__wRjrH {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
  color: #888;
  background: none;
  border: none;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.Dashboard_navButton__wRjrH:hover,
.Dashboard_navButton__wRjrH.Dashboard_active__W8US9 {
  background-color: #222;
  color: #fff;
}

.Dashboard_logout__x5HSE {
  margin-top: auto;
  color: #ff4444 !important;
}

.Dashboard_main__ZGv6P {
  flex: 1 1;
  padding: 1rem;
  width: 90%;
}

.Dashboard_mobileHeader__97Ckv {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #111;
  position: sticky;
  top: 0;
  z-index: 30;
}

.Dashboard_mobileLogo__AwpLS {
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0;
}

.Dashboard_header__iTsYb {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Dashboard_uploadButton__omxEV {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #e50914;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
}

.Dashboard_uploadButton__omxEV:hover {
  background-color: #f40612;
}

.Dashboard_statsGrid__QZIKN {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.Dashboard_statCard__IDFb9 {
  background-color: #b5179836;;
  padding: 1.5rem;
  border-radius: 0.5rem;
  text-align: center;
}

.Dashboard_statCard__IDFb9 h3 {
  margin: 0.5rem 0;
  color: #888;
}

.Dashboard_statCard__IDFb9 p {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
}

.Dashboard_recentUploads__kb8mQ {
  background-color: #111;
  padding: 1.5rem;
  border-radius: 0.5rem;
}

.Dashboard_uploadsList__tFueN {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.Dashboard_uploadItem__hthPo {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background-color: #222;
  border-radius: 0.5rem;
}

.Dashboard_uploadInfo__IjSYR h4 {
  margin: 0;
  font-size: 1rem;
}

.Dashboard_uploadInfo__IjSYR p {
  margin: 0;
  color: #888;
  font-size: 0.875rem;
}

.Dashboard_uploadType__bbtER {
  background-color: #661e2a;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  align-self: flex-start;
  font-weight: 600;
}

.Dashboard_lowerDiv__FqUmS {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-top: 4rem;
  margin-bottom: 4rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.Dashboard_insideDiv__2WLXB {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #1a1a1a, #2a2a2a);
  border-radius: 1rem;
  padding: 0.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.Dashboard_insideDiv__2WLXB:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.Dashboard_insideDiv__2WLXB {
  background: linear-gradient(145deg, #ff525233, #7a2c2c);
  border: 1px solid rgba(255, 82, 82, 0.3);
}

.Dashboard_insideDiv__2WLXB::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.1), transparent 70%);
  pointer-events: none;
}

.Dashboard_iconWrapper__kmOKQ {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Dashboard_insideDiv__2WLXB h3 {
  font-size: 2rem;
  font-weight: bold;
  margin: 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.Dashboard_label__\\+iqL4 {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

/* Responsive adjustments */
@media (min-width: 768px) {
  .Dashboard_lowerDiv__FqUmS {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 639px) {
  .Dashboard_lowerDiv__FqUmS {
    grid-template-columns: 1fr;
  }
}

/* Tablet and Desktop Styles */
@media (min-width: 768px) {
  .Dashboard_container__Py0eR {
    padding-left: 250px;
  }

  .Dashboard_overlay__3rLKG {
    display: none !important;
  }

  .Dashboard_sidebar__duGZ8 {
    left: 0;
  }

  .Dashboard_mobileHeader__97Ckv {
    display: none;
  }

  .Dashboard_header__iTsYb {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
  }

  .Dashboard_uploadButton__omxEV {
    width: auto;
  }

  .Dashboard_statsGrid__QZIKN {
    grid-template-columns: repeat(2, 1fr);
  }

  .Dashboard_uploadItem__hthPo {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .Dashboard_uploadType__bbtER {
    align-self: center;
  }
}

@media (min-width: 1024px) {
  .Dashboard_statsGrid__QZIKN {
    grid-template-columns: repeat(4, 1fr);
  }

  .Dashboard_main__ZGv6P {
    padding: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,WAAW;AACb;;AAEA,4FAA4F;AAC5F;EACE,sBAAsB;EACtB,aAAa;EACb,0BAA0B,EAAE,gDAAgD;EAC5E,eAAe;EACf,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uDAAuD;EACvD,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  display: flex;\n  min-height: 100vh;\n  background-color: #000;\n  color: #fff;\n  position: relative;\n  padding-top: 5rem;\n}\n\n.overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 40;\n}\n\n/* Sidebar becomes a flex container so that the header remains fixed while the nav scrolls */\n.sidebar {\n  background-color: #111;\n  padding: 1rem;\n  height: calc(100vh - 5rem); /* Adjust height to account for the top offset */\n  position: fixed;\n  left: -280px;\n  top: 5rem;\n  transition: left 0.3s ease;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar.open {\n  left: 0;\n}\n\n.sidebarHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  flex-shrink: 0;\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #fff;\n}\n\n.menuButton {\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding-bottom: 2rem;\n}\n\n.navButton {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem;\n  color: #888;\n  background: none;\n  border: none;\n  border-radius: 0.5rem;\n  transition: all 0.2s ease;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n}\n\n.navButton:hover,\n.navButton.active {\n  background-color: #222;\n  color: #fff;\n}\n\n.logout {\n  margin-top: auto;\n  color: #ff4444 !important;\n}\n\n.main {\n  flex: 1;\n  padding: 1rem;\n  width: 90%;\n}\n\n.mobileHeader {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #111;\n  position: sticky;\n  top: 0;\n  z-index: 30;\n}\n\n.mobileLogo {\n  font-size: 1.25rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.uploadButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: #e50914;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  width: 100%;\n}\n\n.uploadButton:hover {\n  background-color: #f40612;\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.statCard {\n  background-color: #b5179836;;\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n\n.statCard h3 {\n  margin: 0.5rem 0;\n  color: #888;\n}\n\n.statCard p {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n.recentUploads {\n  background-color: #111;\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n}\n\n.uploadsList {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.uploadItem {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #222;\n  border-radius: 0.5rem;\n}\n\n.uploadInfo h4 {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.uploadInfo p {\n  margin: 0;\n  color: #888;\n  font-size: 0.875rem;\n}\n\n.uploadType {\n  background-color: #661e2a;\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.875rem;\n  align-self: flex-start;\n  font-weight: 600;\n}\n\n.lowerDiv {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.insideDiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #1a1a1a, #2a2a2a);\n  border-radius: 1rem;\n  padding: 0.5rem;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.insideDiv:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n}\n\n.insideDiv {\n  background: linear-gradient(145deg, #ff525233, #7a2c2c);\n  border: 1px solid rgba(255, 82, 82, 0.3);\n}\n\n.insideDiv::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.1), transparent 70%);\n  pointer-events: none;\n}\n\n.iconWrapper {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.insideDiv h3 {\n  font-size: 2rem;\n  font-weight: bold;\n  margin: 0.5rem 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.label {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n/* Responsive adjustments */\n@media (min-width: 768px) {\n  .lowerDiv {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 639px) {\n  .lowerDiv {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Tablet and Desktop Styles */\n@media (min-width: 768px) {\n  .container {\n    padding-left: 250px;\n  }\n\n  .overlay {\n    display: none !important;\n  }\n\n  .sidebar {\n    left: 0;\n  }\n\n  .mobileHeader {\n    display: none;\n  }\n\n  .header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n  }\n\n  .uploadButton {\n    width: auto;\n  }\n\n  .statsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .uploadItem {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .uploadType {\n    align-self: center;\n  }\n}\n\n@media (min-width: 1024px) {\n  .statsGrid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .main {\n    padding: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dashboard_container__Py0eR`,
	"overlay": `Dashboard_overlay__3rLKG`,
	"sidebar": `Dashboard_sidebar__duGZ8`,
	"open": `Dashboard_open__DdRZ7`,
	"sidebarHeader": `Dashboard_sidebarHeader__N0DXS`,
	"logo": `Dashboard_logo__6+i8F`,
	"menuButton": `Dashboard_menuButton__UCLmC`,
	"nav": `Dashboard_nav__POOmH`,
	"navButton": `Dashboard_navButton__wRjrH`,
	"active": `Dashboard_active__W8US9`,
	"logout": `Dashboard_logout__x5HSE`,
	"main": `Dashboard_main__ZGv6P`,
	"mobileHeader": `Dashboard_mobileHeader__97Ckv`,
	"mobileLogo": `Dashboard_mobileLogo__AwpLS`,
	"header": `Dashboard_header__iTsYb`,
	"uploadButton": `Dashboard_uploadButton__omxEV`,
	"statsGrid": `Dashboard_statsGrid__QZIKN`,
	"statCard": `Dashboard_statCard__IDFb9`,
	"recentUploads": `Dashboard_recentUploads__kb8mQ`,
	"uploadsList": `Dashboard_uploadsList__tFueN`,
	"uploadItem": `Dashboard_uploadItem__hthPo`,
	"uploadInfo": `Dashboard_uploadInfo__IjSYR`,
	"uploadType": `Dashboard_uploadType__bbtER`,
	"lowerDiv": `Dashboard_lowerDiv__FqUmS`,
	"insideDiv": `Dashboard_insideDiv__2WLXB`,
	"iconWrapper": `Dashboard_iconWrapper__kmOKQ`,
	"label": `Dashboard_label__+iqL4`
};
export default ___CSS_LOADER_EXPORT___;
